// export default {
//   index: {
//     logo: "YiSuCloud",
//     Billing: "Billing",
//     Referral: "Referral Program",
//     Products: "Products",
//     Support: "Support"
//   },
//   menu: {
//     overview: 'Overview',
//     products: 'Products',
//     server: 'Elastic Compute Cloud',
//     baremetal: 'Bare Metal Server',
//     mysql: 'MySQL',
//     elb: 'Elastic Load Balancer',
//     ssl: 'SSL Certificate',
//     ip: 'Anti-DDoS IP',
//     account: 'Account',
//     billing: 'Billing',
//     profile: "My Profile",
//     help: 'Help & Support'
//   }

// }



import common from './common';
import menu from './menu';
import overview from './overview';
import ssl from './ssl';
import mysql from './mysql';
import bms from './bms';
import elb from './elb';
import defense from './defense';
import ecc from './ecc'
import user from './user';
import lightserver from './lightserver';
import referral from "./referral";

export default {
  ...common,
  ...menu,
  ...overview,
  ...ssl,
  ...mysql,
  ...bms,
  ...elb,
  ...defense,
  ...ecc,
  ...user,
  ...overview,
  ...lightserver,
  ...referral
}



// WEBPACK FOOTER //
// ./src/lang/en/en.js